import './styles.modules.scss';
import React from 'react';
import { OptionRecord } from '../types';
import { getPublicImageUrl } from '~utils/image';

type OptionSelectorProps = {
  optionLabel: string;
  selectedOption: string;
  options: OptionRecord;
  onSelect: (type: string) => void;
};

const OptionSelector: React.FC<OptionSelectorProps> = ({
  optionLabel,
  selectedOption,
  options,
  onSelect,
}) => (
  <div className="mb-4">
    <label>
      {optionLabel}：{selectedOption}
    </label>
    <div styleName="product-options">
      {Object.entries(options).map(([option, { imageKey }]) => (
        <div key={option} className="mr-3 mb-3">
          <div styleName={`product-option`} onClick={() => onSelect(option)}>
            {!imageKey && (
              <div
                styleName={`option${
                  option === selectedOption ? ' selected' : ''
                }`}
                className="d-flex justify-content-center align-items-center w-100 p-3"
              >
                {option}
              </div>
            )}
            {imageKey && (
              <img
                styleName={`option${
                  option === selectedOption ? ' selected' : ''
                }`}
                src={getPublicImageUrl(imageKey, 'small')}
                alt={option}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default OptionSelector;
